import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActiveNavStateService } from '@app/modules/nav/services/active-nav-state.service';
import { NavStateService } from '@app/modules/nav/services/nav-state.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpRightFromSquare, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap/accordion/accordion.directive';

@Component({
    selector: 'fdx-app-vertical-menu-expanded',
    templateUrl: './app-vertical-menu-expanded.component.html',
    styleUrls: ['./app-vertical-menu-expanded.component.scss', '../app-vertical-menu/app-vertical-menu-buttons.scss'],
    standalone: false
})
export class AppVerticalMenuExpandedComponent implements AfterViewInit {
        @ViewChild('accordion') accordion: NgbAccordionDirective;

    protected readonly faChevronRight: IconDefinition = faChevronRight;
    protected readonly faArrowUpRightFromSquare: IconDefinition = faArrowUpRightFromSquare;

    constructor(
        protected readonly activeNavState: ActiveNavStateService,
        protected readonly navState: NavStateService
    ) { }

    ngAfterViewInit(): void {
        this.accordion.expand(this.activeNavState.activeNavGroupId);
    }

    getNavGroupClasses(id: string): string {
        if (!this.activeNavState.isNavGroupSelected(id)) {
            return 'unselected-item';
        }


        return this.activeNavState.isSubNavUnset()
        ? 'selected-item active-selected-item'
        : 'partially-selected-item';
    }

    getSubNavClasses(id: string): string {
        if (!this.activeNavState.isSubNavSelected(id)) {
            return 'unselected-sub-nav';
        }

        return 'selected-sub-nav';
    }

    /**
     * Nav Group is only considered fully selected if no sub nav items are selected
     * @param id
     */
    isNavGroupSelected(id: string): boolean {
        return this.activeNavState.isNavGroupSelected(id) && this.activeNavState.isSubNavUnset();
    }

    isAccordionItemOpen(id: string): boolean {
        return this.accordion?.isExpanded(id);
    }

    onToggleNavGroup(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    onNavGroupClick(e: MouseEvent, id: string): void {
        if (e.target instanceof HTMLButtonElement) {
            e.preventDefault();
            return;
        }

        this.accordion.expand(id);
    }
}
